<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>
                Send an invitation to
            </h2>
        </template>
        <template v-slot:body>
            <div class="form-group">
                <label class="form-label required">Email</label>
                <input
                    name="email"
                    class="form-control"
                    :class="{'has-error': errors.first('email') }"
                    autocomplete="off"
                    v-model="formData.email"
                    v-validate="{ required: true, email: true }"
                    data-vv-delay="1000"
                    data-vv-as="email address"
                >
                <div class="form-error">{{ errors.first('email') }}</div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    :disabled="isLoading"
                    @click.prevent="onSendInvitation"
                >
                    Send invitation
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import { push422ErrorsToValidator } from '@helpers/helpers';
import SimpleModal from '@components/partials/modal/SimpleModal.vue';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                email: '',
            },
            isLoading: false,
        };
    },
    watch: {
        showModal(isOpened) {
            if (!isOpened) {
                this.formData = {
                    email: '',
                };
            }
            this.$validator.reset();
        },
    },
    methods: {
        onSendInvitation() {
            this.$validator.validate().then(async (valid) => {
                if (valid) {
                    this.isLoading = true;
                    this.axios.post('/api/user/send-invitation', this.formData)
                        .then((res) => res.data)
                        .then(({ data }) => {
                            this.$emit('close');
                            let description = `To: ${data.email}<br>`;
                            description += `Expires at: ${data.expires_at}`;
                            window.showSuccess('Invitation sent.', description);
                        })
                        .catch((error) => {
                            push422ErrorsToValidator(error, this.$validator);
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
